import React, { Dispatch } from "react"
import { StockBenefitPanel } from "components/organisms/panel/stockBenefit"
import { APIResponse } from "redux/apis/types"
import {
  useBenefitActionType,
  useBenefitStateType,
} from "components/actions/tool"
import { MainContainer } from "components/molecules/utils/mainContainer"
import { DataDescription } from "../../organisms/panel/dataDescription"
import { SymbolSearchDisclaimerText } from "config/disclaimerText"
import { checkIsSp } from "../../../utils/util"

type StockBenefitTemplateType = {
  response: APIResponse.Res
  stockBenefitState: useBenefitStateType
  stockBenefitAction: Dispatch<useBenefitActionType>
}

export const StockBenefitTemplate: React.FC<
  StockBenefitTemplateType
> = props => {
  const isSP = checkIsSp()
  return (
    <MainContainer>
      <div>
        <StockBenefitPanel {...props} />
      </div>
      {!isSP && (
        <DataDescription
          className="panel-data-description"
          children={SymbolSearchDisclaimerText}
        />
      )}
    </MainContainer>
  )
}
